import { jsonDataStatusSimulation } from "../types/initStore/initSimulation";
import { entriesSumTask, sumExtraResource, sumHoursExtra, whatAreaIsConclued } from "./checkEntriesProject";
import { trimSpaces } from "./textTransform";

export const isEmptyObject = (obj) => {
	return Object.keys(obj).length === 0 && obj.constructor === Object;
};

const namesEquivalency = {
	assetMoneyMX: "MX",
	assetMoneyDLL: "Dll",
	providerMoneyMX: "MX",
	providerMoneyDLL: "Dll",
};

export const getTableEquivalencySimulation = (infoEquivalency = {}) => {
	let tableEquivalency = [];
	for (const key in infoEquivalency) {
		if (Object.hasOwnProperty.call(infoEquivalency, key)) {
			const element = infoEquivalency[key];
			let structureJson = {
				name: namesEquivalency[key],
				hrs: element,
			};
			tableEquivalency.push({
				key: key,
				...structureJson,
			});
		}
	}
	return { tableEquivalency };
};

export const getTableAssetsSimulation = (assets = [], areas = [], equivalencyHrs = { usd: 0, mxn: 0 }) => {
	let tableAssets = [];
	assets.forEach((asset, index) => {
		const nameCurrency = trimSpaces(asset.currency);
		const numberEquivalency = equivalencyHrs[nameCurrency];
		let equivalency = asset.price / numberEquivalency;
		if (isNaN(equivalency) || equivalency === Infinity) {
			equivalency = 0;
		}
		const area = areas.find((area) => asset.areaUserId === area._id);
		tableAssets.push({
			indexData: index,
			key: asset._id,
			...asset,
			equivalencyHrs: parseFloat(equivalency.toFixed(2)),
			area: area === undefined ? "Error" : area.name,
		});
	});
	return { tableAssets };
};

export const getTableProvidersSimulation = (providers = [], areas = [], equivalencyHrs = { usd: 0, mxn: 0 }) => {
	let tableProvider = [];
	let tableProviderSimulation = [];
	providers.forEach((provider, index) => {
		const nameCurrency = trimSpaces(provider.currency);
		const numberEquivalency = equivalencyHrs[nameCurrency];
		const area = areas.find((area) => provider.areaUserId === area._id);
		let equivalency = provider.price / numberEquivalency;
		if (isNaN(equivalency) || equivalency === Infinity) {
			equivalency = 0;
		}
		const structureJson = {
			indexData: index,
			key: provider._id,
			...provider,
			area: area === undefined ? "Error" : area.name,
		};
		if (provider.type === "A") {
			structureJson.equivalencyHrs = parseFloat(equivalency.toFixed(2));
			tableProvider.push(structureJson);
		}
		if (provider.type === "B") {
			const realMoney = numberEquivalency * provider.outsourceHours;
			structureJson.outsourceHours = provider.outsourceHours;
			structureJson.realmoney = parseFloat(realMoney.toFixed(2));
			structureJson.budgetInit = parseFloat((realMoney * 0.75).toFixed(2));
			structureJson.budgetMax = parseFloat((realMoney * 1.1).toFixed(2));
			tableProviderSimulation.push(structureJson);
		}
	});
	return { tableProvider, tableProviderSimulation };
};

export const getTableInfoSimulation = (assets = [], providers = [], clickups = {}, clikcupInfo = { hrsTotal: 0, planning: 0, develop: 0 }) => {
	const { name, status, tasksSelect, extraResources, extraTime, budget } = clickups;

	const { sumByArea: sumByAreaTask } = entriesSumTask(tasksSelect, name);
	const { sumByArea: sumByAreaExtraResource } = sumExtraResource(extraResources);
	const { sumByArea: sumByAreaExtra } = sumHoursExtra(extraTime);

	let tableInfoHrs = Object.entries(sumByAreaTask).map(([key, value]) => {
		const budgetByArea = budget[key];
		const { nameValue } = whatAreaIsConclued(key);
		const sumAreaProjection = sumByAreaTask[key].selectHours + sumByAreaExtraResource[key].hours + sumByAreaExtra[key].hours;
		const sumAreaWork = sumByAreaTask[key].hours + sumByAreaExtraResource[key].hours + sumByAreaExtra[key].hours;
		let totalAssets = assets.reduce((sum, project) => {
			if (trimSpaces(nameValue) === trimSpaces(project.area) && project.status === jsonDataStatusSimulation.Simulation.name) {
				return sum + project.equivalencyHrs;
			}
			return sum;
		}, 0);
		let totalProviders = providers.reduce((sum, project) => {
			const isSumProvider = trimSpaces(nameValue) === trimSpaces(project.area) && project.status === jsonDataStatusSimulation.Simulation.name;
			if (isSumProvider && project.type === "A") {
				return sum + project.equivalencyHrs;
			}
			if (isSumProvider && project.type === "B") {
				return sum + project.outsourceHours;
			}
			return sum;
		}, 0);

		const sumGlobalHrs = sumAreaProjection + totalAssets + totalProviders;
		const remainingTotal = budgetByArea - sumGlobalHrs;
		return {
			key: `${nameValue}-value-simulation`,
			name: nameValue,
			budget: budgetByArea, //* A
			hrsWork: parseFloat(sumAreaWork.toFixed(2)), //* clickup + extra resource + extra time  B
			projection: parseFloat(sumAreaProjection.toFixed(2)), //* C
			hrsAssets: parseFloat(totalAssets.toFixed(2)), //* assets simulacion D
			hrsProvider: parseFloat(totalProviders.toFixed(2)), //* provedor simulacion E
			hrsRemaining: parseFloat(remainingTotal.toFixed(2)), //*  A-(C+D+E)
		};
	});

	let tableInfo = [
		{
			key: `hrs-info-simulation-1`,
			name: "Planeación",
			hrs: parseFloat(clikcupInfo.planning.toFixed(2)),
		},
		{
			key: `hrs-info-simulation-2`,
			name: "Desarrollo",
			hrs: parseFloat(clikcupInfo.develop.toFixed(2)),
		},
		{
			key: `hrs-info-simulation-0`,
			name: "Horas totales",
			hrs: parseFloat(clikcupInfo.hrsTotal.toFixed(2)),
		},
	];

	return {
		tableInfo,
		tableInfoHrs,
		infoText: {
			nameProject: name,
			statusProject: status,
		},
	};
};
